/**
 * Helpers for the V2 global location filter.
 *
 * `selectedLocation` (from LocationContext) is a string like "Auburn, WA",
 * "Grand Prairie, TX", or "All, USA". V2's filter operates at the *state*
 * level — we only care whether the row's location ends with the same state
 * code.
 */

export function selectedStateCode(selectedLocation: string | null): string | null {
  if (!selectedLocation) return null;
  if (selectedLocation === 'All, USA') return null;
  const parts = selectedLocation.split(',').map((s) => s.trim());
  return parts[1] || null;
}

export function rowMatchesState(
  rowLocation: string | undefined,
  stateCode: string | null
): boolean {
  if (!stateCode) return true;
  if (!rowLocation) return false;
  const trimmed = rowLocation.trim();
  // Row locations are stored as "City StateCode" (e.g. "Grand Prairie TX") —
  // a trailing whitespace match is safer than `endsWith` (avoids accidentally
  // matching e.g. "Houston EAST" if stateCode were "EAST").
  return (
    trimmed === stateCode ||
    trimmed.endsWith(' ' + stateCode) ||
    trimmed.endsWith(', ' + stateCode)
  );
}
